import { Menu } from "@headlessui/react";

export const CategoriesActionMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handlePublishCatagoriesPage
}) => {
    return (
        <>
        <Menu as="div" className="relative text-left -ml-2">
									<div>
										{/* <Menu.Button
											onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
											className="p-2 bg-slate-300 hover:bg-slate-400 text-gray-800 hover:text-gray-900 rounded cursor-pointer"
											title="More Actions..."
										>
											<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
												<path d="M13.5 4.5C13.5 3.67157 12.8284 3 12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 12 6C12.8284 6 13.5 5.32843 13.5 4.5Z" stroke="currentColor" stroke-width="1.5" />
												<path d="M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12Z" stroke="currentColor" stroke-width="1.5" />
												<path d="M13.5 19.5C13.5 18.6716 12.8284 18 12 18C11.1716 18 10.5 18.6716 10.5 19.5C10.5 20.3284 11.1716 21 12 21C12.8284 21 13.5 20.3284 13.5 19.5Z" stroke="currentColor" stroke-width="1.5" />
											</svg>
										</Menu.Button> */}
									</div>
									{anchorShipmentEl && (
										<Menu.Items className="absolute z-20 ms-3 my-1 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }}>
											<div className="px-1 py-1">
												{/* Catagories Related Actions Section */}
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handlePublishCatagoriesPage();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-200' : ''
																} group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
														// title="Publish Collections"
														>
															<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="28" height="24">
																<path d="M6 18a6 6 0 0 1-6-6 6 6 0 0 1 6-6c.3 0 .6.03.9.08a5.992 5.992 0 0 1 11.2 0C18.4 6.03 18.7 6 19 6a6 6 0 0 1 6 6 6 6 0 0 1-6 6h-2z" fill="none" stroke="currentColor" stroke-width="2" />
																<path d="M14 10l4 4-4 4-4-4 4-4z" stroke="currentColor" stroke-width="2" />
																<path d="M16 16l-4 4-4-4" stroke="currentColor" stroke-width="2" />
															</svg>
															<span className='mx-3'>Publish Catagories</span>
														</button>
													)}
												</Menu.Item>
											</div>
										</Menu.Items>
									)}
								</Menu>
        </>
    )
}